<dx-select-box #selectBox
               acceptCustomValue="false"
               displayExpr="name"
               searchEnabled="true"
               valueExpr="id"
               [dataSource]="fileTransfers"
               [disabled]="isDisabled"
               [noDataText]="'_pickers.nodata' | translate"
               [placeholder]="'_pickers.placeholder' | translate"
               [showClearButton]="!isRequired"
               (selectedItemChange)="onSelectedItemChange($event)">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgFileTransferRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
